import {
  useCommentState,
  CommentField,
  Button,
  Stack,
} from '@gogame/components';

export const CommentForm = ({
  initialValue,
  onChange,
  label = 'Comment',
  autoFocus = false,
  onCancel,
}) => {
  const { field, dirty, open, close, isValid } = useCommentState({
    initialValue,
  });

  const handleCancel = () => {
    close();
    onCancel && onCancel();
  };

  const handleSave = () => {
    if (isValid() && onChange) {
      onChange({ target: { value: field.value } }, field.value);
    }
  };

  return (
    <Stack spacing={2} direction={'column'} sx={{ pt: 2 }}>
      <CommentField
        label={label}
        autoFocus={autoFocus}
        error={field.error}
        value={field.value}
        onFocus={field.onFocus}
        onChange={field.onChange}
      />

      {open ? (
        <Stack spacing={2} direction={'row'} justifyContent={'flex-end'}>
          <Button onClick={handleCancel}>Cancel</Button>
          <Button onClick={handleSave} disabled={!dirty} variant={'contained'}>
            Save
          </Button>
        </Stack>
      ) : null}
    </Stack>
  );
};

export default CommentForm;
